class ApexTabsManager {
  constructor({ tabSelector, containerSelector }) {
    this.tabSelector = tabSelector;
    this.containerSelector = containerSelector;
    this.init();
  }

  init() {
    this.tabs = document.querySelectorAll(this.tabSelector);
    this.containers = document.querySelectorAll(this.containerSelector);

    if (this.tabs.length === 0 || this.containers.length === 0) {
      console.warn("Tabs or containers not found");
      return;
    }

    this.bindEvents();
    this.setDefaultActive();
  }

  bindEvents() {
    this.tabs.forEach((tab) => {
      tab.addEventListener("click", () => this.onTabClick(tab));
    });
  }

  onTabClick(clickedTab) {
    const key = clickedTab.getAttribute("data-key");

    this.tabs.forEach((tab) => tab.classList.remove("active"));
    this.containers.forEach((container) => container.classList.remove("active"));

    clickedTab.classList.add("active");
    const targetContainer = document.querySelector(`${this.containerSelector}[data-key="${key}"]`);

    if (targetContainer) {
      targetContainer.classList.add("active");
    }
  }

  setDefaultActive() {
    if (this.tabs.length > 0 && this.containers.length > 0) {
      this.tabs[0].classList.add("active");
      const key = this.tabs[0].getAttribute("data-key");
      const defaultContainer = document.querySelector(`${this.containerSelector}[data-key="${key}"]`);

      if (defaultContainer) {
        defaultContainer.classList.add("active");
      }
    }
  }
}

window.ApexTabsManager = ApexTabsManager;